import {Component, OnInit} from '@angular/core';
import {FormArray, FormGroup, Validators} from '@angular/forms';
import {FormControl} from '@angular/forms';
import {UserProfile} from '../../models/user.model';
import {Observable} from 'rxjs';
import {UserCoreService} from '@cas-hub/acabim-common-client';
import {MessageService, PrimeNGConfig} from 'primeng/api';

@Component({
    selector: 'acabim-user-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    providers: [MessageService]

})

export class ProfileComponent implements OnInit {
    userDataOptions = [{label: 'work', value: 'work'},
        {label: 'home', value: 'home'}];
    // @ts-ignore
    userForm: FormGroup;
    index = 0;
    addAlert = '';
    deleteAlert = '';
    validatorPh = Validators.pattern('^[0-9 ]*$');
    validatorEm = Validators.email;
    emailList: any[] = [];
    phoneList: any[] = [];
    addressList: any[] = [];
    isLoading = true;
    userGuid = '';

    constructor(private readonly userCoreService: UserCoreService, private messageService: MessageService, private primengConfig: PrimeNGConfig) {
    }

    async ngOnInit() {
        this.primengConfig.ripple = true;
        // Initialize user form group
        this.userForm = new FormGroup({
            userFirstName: new FormControl(''),
            userFamilyName: new FormControl(''),
            emails: new FormArray([]),
            phones: new FormArray([]),
            addresses: new FormArray([]),
        });
        this.userProfile.subscribe(data => {
                // console.log(data);
                // sort properties from api according to types
                this.userGuid = data.userId;
                if (data.properties.length > 0) {
                    data.properties.forEach((value) => {
                        if (value.type === 'Phone') {
                            this.phoneList.push(new FormGroup({
                                id: new FormControl(value.id),
                                select_ph: new FormControl(value.isDefault),
                                input_ph: new FormControl(value.value, Validators.pattern('^[0-9 ]*$')),
                                type_ph: new FormControl({
                                    label: value.label, value: value.label
                                }),
                            }));
                        } else if (value.type === 'Address') {
                            this.addressList.push(new FormGroup({
                                id: new FormControl(value.id),
                                select_ad: new FormControl(value.isDefault),
                                input_ad: new FormControl(value.value),
                                type_ad: new FormControl({
                                    label: value.label, value: value.label
                                }),
                            }));
                        } else if (value.type === 'Email') {
                            console.log(value);
                            this.emailList.push(new FormGroup({
                                id: new FormControl(value.id),
                                select_em: new FormControl({value: value.isDefault, disabled: true}),
                                input_em: new FormControl({value: value.value, disabled: value.isDefault}, [Validators.required, Validators.email]),
                                type_em: new FormControl({
                                    value: {
                                        label: value.label, value: value.label
                                    },
                                    disabled: value.isDefault
                                }),
                            }));
                        }
                    });
                }

                this.userForm.patchValue({
                    userFirstName: data.firstName,
                    userFamilyName: data.familyName,
                });

                if (this.phoneList.length > 0) {
                    this.phoneList.forEach((value, index) => {
                        (this.userForm.get('phones') as FormArray).push(this.phoneList[index]);
                    });
                }
                if (this.emailList.length > 0) {
                    this.emailList.forEach((value, index) => {
                        (this.userForm.get('emails') as FormArray).push(this.emailList[index]);
                    });
                }
                if (this.addressList.length > 0) {
                    this.addressList.forEach((value, index) => {
                        (this.userForm.get('addresses') as FormArray).push(this.addressList[index]);
                    });
                }
                this.isLoading = false;
            },
            error => {
            });
    }

    onAdd(type: string) {
        this.addAlert = type;
        this.isLoading = false;
    }


    onDelete(type: string, i: number) {
        this.deleteAlert = type;
        this.index = i;
        this.isLoading = false;
    }


    get emailControls(): FormArray {
        return this.userForm.get('emails') as FormArray;
    }

    get phoneControls(): FormArray {
        return this.userForm.get('phones') as FormArray;
    }

    get addressControls(): FormArray {
        return this.userForm.get('addresses') as FormArray;
    }

    onSubmitAddAlert(group?: FormGroup, type?: string) {
        this.addAlert = '';
        this.isLoading = true;
        if (group !== undefined) {
            switch (type) {
                case 'phone': {
                    // @ts-ignore
                    this.userCoreService.addUserProfileProperty('Phone', group.get('detail').value, group.get('default').value, group.get('type').value.label)
                        .subscribe((data: any) => {
                            this.isLoading = false;
                            const control = new FormGroup({
                                id: new FormControl(data.id),
                                select_ph: group.get('default') as FormControl,
                                input_ph: group.get('detail') as FormControl,
                                type_ph: group.get('type') as FormControl,
                            });
                            (this.userForm.get('phones') as FormArray).push(control);
                            console.log(data);
                        }, (error: any) => {
                            console.log(error);
                        });
                    break;
                }
                case 'email': {
                    // @ts-ignore
                    this.userCoreService.addUserProfileProperty('Email', group.get('detail').value, group.get('default').value, group.get('type').value.label)
                        .subscribe((data: any) => {
                            this.isLoading = false;
                            const control = new FormGroup({
                                id: new FormControl(data.id),
                                select_em: group.get('default') as FormControl,
                                input_em: group.get('detail') as FormControl,
                                type_em: group.get('type') as FormControl,
                            });
                            (this.userForm.get('emails') as FormArray).push(control);
                        }, (error: any) => {
                        });
                    break;
                }
                case 'address': {

                    // @ts-ignore
                    this.userCoreService.addUserProfileProperty('Address', group.get('detail').value, group.get('default').value, group.get('type').value.label)
                        .subscribe((data: any) => {
                            this.isLoading = false;
                            const control = new FormGroup({
                                id: new FormControl(data.id),
                                select_ad: group.get('default') as FormControl,
                                input_ad: group.get('detail') as FormControl,
                                type_ad: group.get('type') as FormControl,
                            });
                            (this.userForm.get('addresses') as FormArray).push(control);
                            console.log(data);
                        }, (error: any) => {
                            console.log(error);
                        });
                    break;
                }
                default: {
                    this.isLoading = false;
                    break;
                }
            }
        } else {
            this.isLoading = false;
        }
    }

    onSubmitDeleteAlert(str: string, i: number, type: string) {
        this.deleteAlert = '';
        this.isLoading = true;
        if (str === 'delete') {
            // @ts-ignore
            const deleteId = (this.userForm.get(type) as FormArray).controls[i].controls.id.value;

            this.userCoreService.removeUserProfileProperty(deleteId).subscribe((data: any) => {
                this.isLoading = false;
                console.log(data);
                (this.userForm.get(type) as FormArray).removeAt(i);

            }, (error: any) => {
                this.isLoading = false;
                this.messageService.clear();
                this.messageService.add({
                    sticky: true,
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry, cannot delete selected data'
                });
            });

        } else {
            this.isLoading = false;
        }
    }


    private get userProfile(): Observable<UserProfile> {
        return this.userCoreService.getUserProfile();
    }


    async onSubmit() {
        this.isLoading = true;
        // this.userCoreService.updateFirstName(this.userForm.controls.userFirstName)
        if (this.userForm.controls.userFirstName.value) {
            await this.userCoreService.updateFirstName(this.userForm.controls.userFirstName.value).subscribe(data => {
                console.log(data);
                if (this.userForm.controls.userFamilyName.value !== null) {
                    this.userCoreService.updateFamilyName(this.userForm.controls.userFamilyName.value).subscribe(d => {
                        console.log(d);
                        this.isLoading = false;

                    });
                }
                this.isLoading = false;
            }, error => {
                this.messageService.clear();
                this.messageService.add({
                    sticky: true,
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry, cannot update user First Name'
                });
                this.isLoading = false;

            });
        } else if (this.userForm.controls.userFamilyName.value) {
            await this.userCoreService.updateFamilyName(this.userForm.controls.userFamilyName.value).subscribe(data => {
                console.log(data);
                this.isLoading = false;

            }, error => {
                this.messageService.clear();
                this.messageService.add({
                    sticky: true,
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry, cannot update user Family Name'
                });
                this.isLoading = false;
            });
        }
        (this.userForm.get('phones') as FormArray).controls.forEach(control => {
            console.log(control);
            // @ts-ignore
            // tslint:disable-next-line:max-line-length
            this.userCoreService.updateUserProfileProperty(control.controls.id.value, control.controls.select_ph.value, 'Phone', control.controls.input_ph.value, control.controls.type_ph.value.label)
                .subscribe((data) => {
                    console.log(data);
                    this.isLoading = false;
                }, error => {
                    this.messageService.clear();
                    this.messageService.add({
                        sticky: true,
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Sorry, cannot update user phones info'
                    });
                    this.isLoading = false;
                });
        });
        for (const control of (this.userForm.get('emails') as FormArray).controls) {
            console.log(control);
            // @ts-ignore
            if (!control.controls.select_em.value) {
                // @ts-ignore
                // tslint:disable-next-line:max-line-length
                await this.userCoreService.updateUserProfileProperty(control.controls.id.value, control.controls.select_em.value, 'Email', control.controls.input_em.value, control.controls.type_em.value.label)
                    .subscribe((data) => {
                        console.log(data);
                        this.isLoading = false;

                    }, error => {
                        this.messageService.clear();
                        this.messageService.add({
                            sticky: true,
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Sorry, cannot update user email info'
                        });
                        this.isLoading = false;
                    });
            }
        }
        for (const control of (this.userForm.get('addresses') as FormArray).controls) {
            console.log(control);
            // @ts-ignore
            // tslint:disable-next-line:max-line-length
            await this.userCoreService.updateUserProfileProperty(control.controls.id.value, control.controls.select_ad.value, 'Address', control.controls.input_ad.value, control.controls.type_ad.value.label)
                .subscribe((data) => {
                    this.isLoading = false;
                }, error => {
                    this.messageService.clear();
                    this.messageService.add({
                        sticky: true,
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Sorry, cannot update user addresses info'
                    });
                    this.isLoading = false;
                });
        }

    }

    setModal(value: boolean): void {
        if (!value) {
            this.onSubmitAddAlert(undefined, 'address');
            this.onSubmitAddAlert(undefined, 'email');
            this.onSubmitAddAlert(undefined, 'phone');

        }
    }
}
